import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { builder } from '@builder.io/react'

export default function useBuilder() {
  const { user, visitor } = useSelector(state => state?.session)

  const gender = user?.gender || visitor?.gender || 'unknown'
  const isSignedIn = !!user
  const isMobile = useSelector(state => state?.appConfig.isMobile)
  const device = isMobile ? 'mobile' : 'desktop'

  const countryCode = useSelector(
    state => state?.session?.visitor?.localization?.country_code ?? null,
  )
  const city = useSelector(state => state?.session?.visitor?.localization?.city ?? null)
  const visitType = visitor?.segment || 'unactivated'

  return useEffect(() => {
    // These attributes need to be kept in-sync with app/controllers/pages_controller,
    // which BuilderHttpClient uses for caching and page lookup.
    // Please modify accordingly.
    builder.setUserAttributes({
      gender,
      device,
      countryCode,
      city,
      visitType,
      isSignedIn,
    })
  }, [gender, device, countryCode, visitType, city, isSignedIn])
}
